<template>
  <div class="eyebrow">{{ text }}</div>
</template>

<script>
export default {
  name: 'Eyebrow',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/typography/type';

.eyebrow {
  @include type.text--mono;

  margin-bottom: vertical-spacing.vert-space(xs);
  color: colors.color(active, secondary);
}
</style>
